
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15","height":"14","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_16322_122479)","stroke":"#339299","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M11.375.5h-7a3 3 0 00-3 3v7a3 3 0 003 3h7a3 3 0 003-3v-7a3 3 0 00-3-3z"}}),_c('path',{attrs:{"d":"M4.875 7l3-3.5 3 3.5M7.875 3.5v7"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_16322_122479"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(.875)","d":"M0 0h14v14H0z"}})])])])
          )
        }
      }
    